const PlaceholderPage = ({ title, description }) => (
  <div className="rounded-xl border border-dashed border-zinc-300 dark:border-zinc-700 bg-white/50 dark:bg-zinc-900/50 p-12 text-center">
    <h2 className="text-xl font-medium text-zinc-800 dark:text-zinc-200">{title}</h2>
    <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-500">{description}</p>
  </div>
);

export default PlaceholderPage;
